import React from "react";

const NewBackButton = ({ width, height, color }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 10 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.72228 1.05566L2.27783 7.50011L8.72228 13.9446'
        stroke={color}
        strokeWidth='2.41667'
      />
    </svg>
  );
};

NewBackButton.defaultProps = {
  width: 10,
  height: 15,
  color: "black",
};

export default NewBackButton;
